import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search, Facebook, Globe, MessageSquare } from "lucide-react";

const ACTIVE = [
  { key: "facebook", name: "Facebook", color: "#1877F2", icon: Facebook, path: "/integrations/facebook" },
  { key: "website", name: "Website / API", color: "#0EA5E9", icon: Globe, path: "/integrations/website" },
  { key: "whatsapp", name: "WhatsApp", color: "#25D366", icon: MessageSquare, path: "/whatsapp" },
  { key: "wacloud", name: "WhatsApp Cloud API", color: "#25D366", icon: MessageSquare, path: "/whatsapp" },
];
const AVAILABLE = [
  ["99acres", "Capture 99acres leads in your CRM"], ["CallerDesk", "Integrate CallerDesk telephony"],
  ["Google Meet", "Schedule counselling calls"], ["Justdial", "Capture Justdial enquiries"],
  ["IndiaMART", "Capture IndiaMART leads"], ["Instagram", "Capture Instagram lead ads"],
  ["Google Ads", "Import Google lead forms"], ["Razorpay", "Collect admission fees"],
  ["Gmail", "Sync counselling emails"], ["Zapier", "Connect 5000+ apps"],
];

export default function Integrations() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const av = AVAILABLE.filter(([n]) => n.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="max-w-4xl">
      <PageHeader title="Integrations" subtitle="Connect OhCampus to your lead sources & communication channels" testid="integrations-header" />
      <div className="relative mb-6">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search integration by name" className="pl-9 bg-white h-11" data-testid="integration-search" />
      </div>

      <h3 className="font-heading font-bold text-[#312E81] mb-3">Active Integration ({ACTIVE.length})</h3>
      <div className="bg-white border border-slate-200 rounded-xl shadow-sm divide-y divide-slate-100 mb-8">
        {ACTIVE.map((a) => {
          const Icon = a.icon;
          return (
            <div key={a.key} className="flex items-center gap-3 px-4 py-3.5" data-testid={`active-${a.key}`}>
              <span className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: `${a.color}1a`, color: a.color }}><Icon className="w-4 h-4" /></span>
              <span className="font-semibold text-slate-800 flex-1">{a.name}</span>
              <span className="inline-flex items-center gap-1.5 text-emerald-700 text-xs font-semibold bg-emerald-50 border border-emerald-200 rounded-full px-2.5 py-1"><span className="w-2 h-2 rounded-full bg-emerald-500" /> Active</span>
              <Button variant="outline" size="sm" className="ml-3" data-testid={`manage-${a.key}`} onClick={() => a.path && navigate(a.path)}>Manage</Button>
            </div>
          );
        })}
      </div>

      <h3 className="font-heading font-bold text-[#312E81] mb-3">Available Integration ({av.length})</h3>
      <div className="bg-white border border-slate-200 rounded-xl shadow-sm divide-y divide-slate-100">
        {av.map(([name, desc]) => (
          <div key={name} className="flex items-center gap-3 px-4 py-3.5">
            <span className="w-8 h-8 rounded-lg bg-slate-100 text-slate-500 flex items-center justify-center text-[11px] font-bold">{name.slice(0, 2)}</span>
            <div className="flex-1"><div className="font-semibold text-slate-800">{name}</div><div className="text-xs text-slate-400">{desc}</div></div>
            <Button variant="outline" size="sm" className="text-[#4F46E5] border-[#4F46E5]/30">Activate now</Button>
          </div>
        ))}
      </div>
    </div>
  );
}
